import styled from 'styled-components';

interface ContainerProps {
  variant: string;
}

interface ValueProps {
  variant: string;
}

export const Value = styled.div<ValueProps>`
  width: 5.19rem;
  font-size: 0.8rem;
  text-align: center;
  color: #fff;

  background-color: ${({ variant }) => {
    if (variant.includes('A')) return '#28A745';
    if (variant.includes('B')) return '#22979A';
    if (variant.includes('C')) return '#960A0A';
    return '#4b1712';
  }};
  @media only screen and (max-width: 768px) {
    max-width: 100%;
    font-size: 0.7rem;
  }
`;

export const Container = styled.div<ContainerProps>`
  position: absolute;
  z-index: 10;
  top: 0;
  left: calc(100% + 8px);

  background-color: #fff;
  padding: 20px;

  width: 540px;
  max-width: min(90vw, 600px);
  min-width: 300px;

  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  border-radius: 12px;

  @media only screen and (max-width: 784px) {
    position: absolute;
    left: 0;
    top: 0;
  }

  .resumo-content {
    display: flex;
    flex-direction: column;
    gap: 6px;
    background-color: #eaeced;
    padding: 10px;
    border-radius: 10px;

    @media only screen and (max-width: 768px) {
      max-width: 13rem;
      strong {
        font-size: 0.8rem !important;
      }
    }
  }

  .indicador-row {
    font-size: 14px;
  }

  .label {
    min-width: 10.7rem;
    @media only screen and (max-width: 768px) {
      min-width: 7rem;
    }
  }

  .value {
    white-space: nowrap;
    text-align: right;
  }

  .capag-badge {
    width: 6.88rem;
    min-width: 6.88rem;

    border-radius: 8px;
    padding: 12px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    background-color: ${({ variant }) => {
      if (variant.includes('A')) return '#28A745';
      if (variant.includes('B')) return '#22979A';
      if (variant.includes('C')) return '#960A0A';
      return '#520D0D';
    }};

    p {
      margin: 0;
      font-size: 12px;
      color: #fff;
    }

    @media only screen and (max-width: 768px) {
      width: 3.88rem;
      min-width: 3.88rem;
      height: 7.88rem;
      p {
        font-size: 0.65rem !important;
      }
      span {
        font-size: 1.5rem;
        word-wrap: break-word;
      }
    }
  }
  h5 {
    font-size: 16px;
  }

  .texto {
    font-size: 13px;
  }

  .resumo-title {
    font-size: 2rem;
    font-weight: 700;
    color: #fff;
    line-height: 1;
  }

  .capag-info {
    gap: 10px;
  }

  .link-capag {
    font-size: 14px;
    text-decoration: underline;
  }

  #resumo-close {
    background: none;
    border: none;
    font-size: 18px;
    cursor: pointer;
    line-height: 1;
  }
`;
